export default __webpack_public_path__ + "static/media/logo.868c0bd8.png";